import type { ReleaseDefinition } from "@legal-500/redis-db-manager-types";

export function isCustomRelease(def: ReleaseDefinition | null | undefined): boolean {
  if (!def) return false;
  if (def.publications.length > 0) return true;
  if (def.demotionPolicy !== "none") return true;
  if (def.asAt !== undefined && def.asAt !== "") return true;
  return false;
}

export const CUSTOM_RELEASE_DISABLED_TOOLTIP =
  "Custom-release slots can't be made active. Discard or re-sync without a release first.";

export const NON_CORE_SYNC_DISABLED_TOOLTIP =
  "Sync dispatch is currently implemented for the core family only.";
